import axios from "axios";
import type { NavigationFailure, RouteLocationNormalized } from "vue-router";

import { postPageVisit } from "./api/usePageVisitsRequest";

import { productPageCatalog } from "@/app/router/productPages";
import type { ProductPageCatalog } from "@/app/router/productPages";

export interface PageVisit {
  eventId: string
  pageKey: string
}

export const visitForNavigation = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  failure: NavigationFailure | void,
  catalog: ProductPageCatalog = productPageCatalog,
): PageVisit | null => {
  if (failure || to.path === from.path || typeof to.name !== "string") return null;
  const pageKey = catalog.byRouteName.get(to.name)?.key;
  if (!pageKey) return null;

  return { eventId: crypto.randomUUID(), pageKey };
};

export const recordPageVisit = async (visit: PageVisit): Promise<void> => {
  try {
    await postPageVisit(visit);
  }
  catch (error) {
    if (!axios.isAxiosError(error) || (error.response && error.response.status < 500)) return;

    try {
      await new Promise(resolve => setTimeout(resolve, 1_000));
      await postPageVisit(visit);
    }
    catch {
      return;
    }
  }
};
